export default __webpack_public_path__ + "static/media/loading.707b7930.gif";